module.exports = __webpack_public_path__ + "static/media/talks.43f5c290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/talks/talks.jpg
// module id = 545
// module chunks = 0